export default __webpack_public_path__ + "static/media/bx_bxl-facebook-circle.c4a0013a.svg";